<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			columns: number;
			desktop_columns: number;
			body: ISbStoryData[];
			gap: 'gap-5' | 'gap-7' | 'gap-13';
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<div
	class="col-span-full grid grid-cols-{content.columns || 1} 
		lg:grid-cols-{content.desktop_columns || content.columns || 1} {content.gap || 'gap-5'}"
	use:editable={content}
>
	{#each content.body || [] as block}
		<Blok content={block} />
	{/each}
</div>
